import React from 'react'

function ErrorHandler ({ error, reserErrorBoundary }) {
  console.log(error.message)
  window.parent.postMessage({
    command: 'resize',
    params: {
      x: 0,
      y: 0,
      minHeight: 0,
      maxWidth: 0,
      maxHeight: 0
    }
  }, '*')

  console.log('Resizing chat app')

  return (<></>)
}

export default ErrorHandler
